window.addEventListener("load", function () {
    
  
});